<template>  
  <div class="salesmanmybonuslistPage">
      <mu-appbar title="奖金明细">
        <div slot="right" class="title-text" @click="open('top')" >
          <p>筛选 </p>    
          <mu-popup position="top" popupClass="salesmanmybonuslistPage-popup" :open="topPopup" @close="close('top')">
            <mu-content-block>
              <div class="popuptitle delivery-type-order">
                <div class="button-list">                  
                  <mu-flat-button @click="searchTypeChange(1)" label="零售奖金" class="demo-flat-button"/>
                  <mu-flat-button @click="searchTypeChange(2)" label="推广奖金" class="demo-flat-button"/>
                  <mu-flat-button @click="searchTypeChange(3)" label="批发奖金" class="demo-flat-button"/>
                </div>
              </div>              
            </mu-content-block>
          </mu-popup>      
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>
    
    <mu-list>
      <template v-for="aItem in dataList.List">
        <router-link :to="'/salesman/mybonusdetail?zqnum='+aItem.zqnum+'&type='+aItem.bs" :key="aItem.zqnum">
        <mu-list-item  title="">
            <div class="mu-date">{{aItem.jsdate.split('T')[0]}}</div>
            <div class="mu-type">{{aItem.bs == 1?'零售奖金': aItem.bs == 2 ?'推广奖金' : '批发奖金'}}</div>
            <div class="mu-rmb">{{aItem.actualaward.toFixed(2)}}</div>
            <mu-icon value=":fa fa-angle-right"/>
        </mu-list-item>
        <mu-divider shallowInset/>
        </router-link>
      </template>
    </mu-list>

    
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
    <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>
<script>
export default {
  data () {
    return {
      searchType: this.$route.query.type,
      topPopup: false,
      dataList:{
        otherEntity:0,
        List:[]
      }
    }
  },
  mounted(){
    this.getList()
  },
  methods: {
    searchTypeChange (val) {
      this.searchType = val
      this.getList()
      this.close('top')
    },
    getList(){
      var ths = this;   
      
      var url = '/Salesman/SalesmanServer/MobileGetShopJiesuanGold'
      if(this.searchType == '2'){
        url = '/Salesman/SalesmanServer/MobileGetShopRecommendGold'
      }
      else if(this.searchType == '3'){
        url = '/Salesman/SalesmanServer/MobileGetShopPurchaseGold'
      }
      
      ths.$post(
        url
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.dataList.List=[]
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.dataList =  res.Data
          ths.$refs.XRPageTip.initTip()
        }
      });
    },    
    GoHistory(){
      this.$router.goBack()
    },
    open (position) {
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    }
  }
}
</script>
<style>
       body .salesmanmybonuslistPage{
        background: #fff;
      }
      .salesmanmybonuslistPage .mu-appbar{
        position: fixed;
        top: 0;
        z-index: 20180101;
      }
      .salesmanmybonuslistPage .mu-list{
        top: 56px;
        background: #fff;
      }
      .salesmanmybonuslistPage .mu-appbar-title {
        font-size: 16px;
      }
      .salesmanmybonuslistPage .title .mu-icon-button {
        position: absolute;
        left: 0;
        top: 0;
        color:white;
      }
      .salesmanmybonuslistPage .title .title-text {
        margin: 0;
        padding:0;
        line-height: 48px;
      }
      .salesmanmybonuslistPage-popup {
        width: 100%;
        top:46px;
        height: 160px;
        z-index: 1;
        padding: 20px 0;
      }
      .salesmanmybonuslistPage-popup .popuptitle .title{
        overflow: hidden;
      }
      .salesmanmybonuslistPage-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
      }
      .salesmanmybonuslistPage-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
      }
      .salesmanmybonuslistPage-popup .button-list{
        padding: 20px 0;
      }
      .salesmanmybonuslistPage .right .title-text p{
        font-size: 16px;
      }
      .salesmanmybonuslistPage .mu-item-content{
        display: flex;
      }
      .salesmanmybonuslistPage .mu-item-content .mu-type,.salesmanmybonuslistPage .mu-item-content .mu-rmb,.salesmanmybonuslistPage .mu-item-content .mu-date{
        width: 30%;
        text-align: center;
        font-size: 16px;
      }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/mybonuslist.vue